module.exports = __webpack_public_path__ + "ls.svg?3b26ed069970cacdcbf63c9314ad97e1";